export default {
  userAnswer(context, data) {
    context.commit("changeAnswer", data);
  },
};
